import { render, staticRenderFns } from "./overseeFeedback.vue?vue&type=template&id=1a207775&scoped=true"
import script from "./overseeFeedback.vue?vue&type=script&lang=js"
export * from "./overseeFeedback.vue?vue&type=script&lang=js"
import style0 from "./overseeFeedback.vue?vue&type=style&index=0&id=1a207775&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a207775",
  null
  
)

export default component.exports